export default __webpack_public_path__ + "static/media/dribble.b26e1cc6.svg";